function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n        width: 100%;\n        height: 100%;\n        border-radius: 0;\n        border: none;\n        box-shadow: none;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n        width: 100%;\n        height: 500px;\n      "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: ",
        ";\n  margin-bottom: 1.5rem;\n  border: 1px solid ",
        ";\n  box-shadow: 0 4px 12px ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  text-align: center;\n  box-sizing: border-box;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  height: 2.5rem;\n  width: 2.5rem;\n  border: 4px solid ",
        ";\n  border-top-color: transparent;\n  border-radius: 50%;\n  margin-bottom: 1rem;\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.125rem;\n  font-weight: 500;\n  text-align: center;\n  margin-bottom: 0.5rem;\n  color: ",
        ";\n  word-break: break-word;\n  width: 100%;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  max-width: 250px;\n  height: 8px;\n  background-color: ",
        ";\n  border-radius: 9999px;\n  margin: 0.5rem auto 0.5rem auto;\n  overflow: hidden;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  width: ",
        "%;\n  background-color: ",
        ";\n  border-radius: 9999px;\n  transition: width 0.3s ease-in-out;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: ",
        ";\n  margin: 0.5rem 0;\n  text-align: center;\n  width: 100%;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  text-align: center;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: ",
        ";\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: ",
        ";\n  max-width: 28rem;\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n      opacity: 1;\n      transition: none;\n    "
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 1rem;\n  opacity: ",
        ";\n  transition: opacity 0.3s ease-in-out;\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  padding: 0.5rem;\n  border-width: 1px;\n  border-style: solid;\n  border-color: ",
        ";\n  border-radius: 0.375rem;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  svg {\n    width: 1.125rem;\n    height: 1.125rem;\n    stroke: currentColor;\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  height: 30px;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(16, 185, 129, 0.15);\n  padding: 2px 6px;\n  border-radius: 4px;\n  fontSize: 10px;\n  fontWeight: 500;\n  color: ",
        ";\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  opacity: 0.8;\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 6px;\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState, useRef, useEffect, useCallback } from 'react';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { Maximize } from 'lucide-react';
import { Minimize } from 'lucide-react';
import { Button } from "@edusense/shared-ui-kit";
import { useWebContainer } from '@edusense/shared-hooks';
var PreviewContainer = styled.div(_templateObject2(), function(props) {
    return props.theme.paper;
}, function(props) {
    return props.theme.border;
}, function(props) {
    return props.theme.isDark ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.1)';
}, function(param) {
    var $isFullscreen = param.$isFullscreen;
    return $isFullscreen ? css(_templateObject()) : css(_templateObject1());
});
var ContentWrapper = styled.div(_templateObject3());
var LoadingContainer = styled.div(_templateObject4());
var spin = keyframes(_templateObject5());
var Spinner = styled.div(_templateObject6(), function(props) {
    return props.theme.primary;
}, spin);
var LoadingText = styled.p(_templateObject7(), function(props) {
    return props.theme.text;
});
var ProgressBarContainer = styled.div(_templateObject8(), function(props) {
    return props.theme.isDark ? props.theme.paperHover : '#e5e7eb';
});
var ProgressBar = styled.div(_templateObject9(), function(props) {
    return props.$progress;
}, function(props) {
    return props.theme.primary;
});
var ProgressText = styled.p(_templateObject10(), function(props) {
    return props.theme.textSecondary;
});
var ErrorContainer = styled.div(_templateObject11());
var ErrorIcon = styled.div(_templateObject12(), function(props) {
    return props.theme.error;
});
var ErrorTitle = styled.h3(_templateObject13(), function(props) {
    return props.theme.error;
});
var ErrorMessage = styled.p(_templateObject14(), function(props) {
    return props.theme.textSecondary;
});
var PlaceholderContainer = styled.div(_templateObject15());
var PlaceholderText = styled.div(_templateObject16(), function(props) {
    return props.theme.textSecondary;
});
var ControlsOverlay = styled.div(_templateObject18(), function(param) {
    var $show = param.$show;
    return $show ? 1 : 0;
}, function(param) {
    var $isFullscreen = param.$isFullscreen;
    return !$isFullscreen && css(_templateObject17());
});
var ControlsInner = styled.div(_templateObject19());
var ButtonGroup = styled.div(_templateObject20());
var IconButton = styled(Button)(_templateObject21(), function(props) {
    return props.theme.text;
}, function(props) {
    return props.theme.border;
}, function(props) {
    return props.theme.isDark ? 'rgba(255, 255, 255, 0.1)' : '#f3f4f6';
});
var PreviewHeader = styled.div(_templateObject22(), function(props) {
    return props.theme.isDark ? props.theme.paperHover : '#e5e7eb';
}, function(props) {
    return props.theme.border;
});
var SecurityBadge = styled.div(_templateObject23(), function(props) {
    return props.theme.isDark ? '#10b981' : '#059669';
});
var WindowControls = styled.div(_templateObject24());
var ControlButton = styled.div(_templateObject25(), function(props) {
    return props.color;
});
/**
 * 프로젝트 미리보기 컴포넌트 (Styled Components 버전)
 * WebContainer를 사용하여 프로젝트 실행 및 미리보기 제공
 */ var ProjectPreview = function(param) {
    var project = param.project, isFullscreenMode = param.isFullscreenMode, projectZipFilePath = param.projectZipFilePath, onDownload = param.onDownload, onFullscreenToggle = param.onFullscreenToggle;
    var previewRef = useRef(null);
    var iframeContainerRef = useRef(null);
    var _useState = _sliced_to_array(useState(true), 2), showControls = _useState[0], setShowControls = _useState[1];
    var controlsTimeoutRef = useRef(null);
    console.log('[ProjectPreview] projectZipFilePath:', projectZipFilePath);
    var _useWebContainer = useWebContainer({
        projectZipFilePath: projectZipFilePath,
        autoBootInPreview: true
    }), isWebContainerLoading = _useWebContainer.isLoading, webContainerLoadingMessage = _useWebContainer.loadingMessage, loadingProgress = _useWebContainer.loadingProgress, previewUrl = _useWebContainer.previewUrl, webContainerError = _useWebContainer.error, bootWebContainer = _useWebContainer.bootWebContainer, renderError = _useWebContainer.renderError, renderSecureIframe = _useWebContainer.renderSecureIframe, securityInfo = _useWebContainer.securityInfo;
    // 🔒 보안 강화된 iframe을 DOM에 추가
    useEffect(function() {
        if (previewUrl && iframeContainerRef.current) {
            // 기존 iframe 제거
            iframeContainerRef.current.innerHTML = '';
            try {
                // 보안 강화된 iframe 생성 및 추가
                if (renderSecureIframe) {
                    var secureIframe = renderSecureIframe();
                    if (secureIframe) {
                        secureIframe.style.width = '100%';
                        secureIframe.style.height = '100%';
                        secureIframe.style.border = 'none';
                        iframeContainerRef.current.appendChild(secureIframe);
                        return;
                    }
                }
                // 폴백: 기본 iframe (더 관대한 sandbox 설정)
                var fallbackIframe = document.createElement('iframe');
                fallbackIframe.src = previewUrl;
                fallbackIframe.title = "".concat(project.title, " 미리보기");
                fallbackIframe.style.width = '100%';
                fallbackIframe.style.height = '100%';
                fallbackIframe.style.border = 'none';
                // WebContainer 동작을 위한 관대한 sandbox 설정
                fallbackIframe.sandbox.add('allow-scripts', 'allow-same-origin', 'allow-forms', 'allow-popups', 'allow-downloads', 'allow-modals');
                iframeContainerRef.current.appendChild(fallbackIframe);
            } catch (error) {
                console.error('iframe 생성 실패:', error);
            }
        }
    }, [
        previewUrl,
        renderSecureIframe,
        project.title
    ]);
    var toggleFullscreen = function() {
        if (previewRef.current) {
            if (!document.fullscreenElement) {
                previewRef.current.requestFullscreen().catch(function(err) {
                    console.error('Fullscreen error:', err);
                });
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };
    var startControlsTimer = useCallback(function() {
        if (controlsTimeoutRef.current) {
            clearTimeout(controlsTimeoutRef.current);
        }
        controlsTimeoutRef.current = setTimeout(function() {
            if (document.fullscreenElement) {
                setShowControls(false);
            }
        }, 3000);
    }, []);
    useEffect(function() {
        var handleFullscreenChange = function() {
            var isFullscreen = !!document.fullscreenElement;
            onFullscreenToggle(isFullscreen);
            if (isFullscreen) {
                setShowControls(true);
                startControlsTimer();
            } else {
                setShowControls(true);
                if (controlsTimeoutRef.current) {
                    clearTimeout(controlsTimeoutRef.current);
                }
            }
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return function() {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, [
        startControlsTimer,
        onFullscreenToggle
    ]);
    useEffect(function() {
        return function() {
            if (controlsTimeoutRef.current) {
                clearTimeout(controlsTimeoutRef.current);
            }
        };
    }, []);
    var handleMouseMove = useCallback(function() {
        if (isFullscreenMode) {
            setShowControls(true);
            startControlsTimer();
        }
    }, [
        isFullscreenMode,
        startControlsTimer
    ]);
    var handleDownload = function() {
        return onDownload(project.id);
    };
    return /*#__PURE__*/ React.createElement(PreviewContainer, {
        ref: previewRef,
        $isFullscreen: isFullscreenMode,
        onMouseMove: handleMouseMove
    }, /*#__PURE__*/ React.createElement(PreviewHeader, null, /*#__PURE__*/ React.createElement(SecurityBadge, null, "\uD83D\uDEE1️ 보안 샌드박스"), /*#__PURE__*/ React.createElement(WindowControls, null, /*#__PURE__*/ React.createElement(ControlButton, {
        color: "#ff5f57"
    }), " ", /*#__PURE__*/ React.createElement(ControlButton, {
        color: "#febc2e"
    }), " ", /*#__PURE__*/ React.createElement(ControlButton, {
        color: "#28c840"
    }), " ")), /*#__PURE__*/ React.createElement(ContentWrapper, null, isWebContainerLoading ? /*#__PURE__*/ React.createElement(LoadingContainer, null, /*#__PURE__*/ React.createElement(Spinner, null), /*#__PURE__*/ React.createElement(LoadingText, null, webContainerLoadingMessage || '프로젝트 로딩 중...'), loadingProgress > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ProgressBarContainer, null, /*#__PURE__*/ React.createElement(ProgressBar, {
        $progress: loadingProgress
    })), /*#__PURE__*/ React.createElement(ProgressText, null, loadingProgress, "% 완료"))) : webContainerError ? /*#__PURE__*/ React.createElement(ErrorContainer, null, /*#__PURE__*/ React.createElement(ErrorIcon, null, "⚠️"), /*#__PURE__*/ React.createElement(ErrorTitle, null, "미리보기 오류"), /*#__PURE__*/ React.createElement(ErrorMessage, null, renderError())) : previewUrl ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        ref: iframeContainerRef,
        style: {
            width: '100%',
            height: '100%'
        }
    })) : /*#__PURE__*/ React.createElement(PlaceholderContainer, null, /*#__PURE__*/ React.createElement(PlaceholderText, null, "미리보기 준비 중..."))), /*#__PURE__*/ React.createElement(ControlsOverlay, {
        $show: showControls,
        $isFullscreen: isFullscreenMode
    }, /*#__PURE__*/ React.createElement(ControlsInner, null, /*#__PURE__*/ React.createElement(ButtonGroup, null, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: toggleFullscreen,
        variant: "outline",
        size: "sm",
        leftIcon: isFullscreenMode ? /*#__PURE__*/ React.createElement(Minimize, null) : /*#__PURE__*/ React.createElement(Maximize, null)
    })))));
};
export default ProjectPreview;
